module.exports = __webpack_public_path__ + "media/images/new_landing/favicon/mstile-70x70-304e28bfd8c9fb8459c1dc621f62deda.png";